import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { TransactionSyndicService } from '@service/syndic/transaction-syndic.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { TransactionSyndicAddComponent } from '../transaction-syndic-add/transaction-syndic-add.component';

@Component({
  selector: 'app-transaction-syndic-list',
  templateUrl: './transaction-syndic-list.component.html',
  styleUrls: ['./transaction-syndic-list.component.scss']
})
export class TransactionSyndicListComponent implements OnInit {
  @Input() transactions: any[] = [];
  @Input() trusteeUuid: string = '';
  @Input() compteUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private transactionService: TransactionSyndicService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'TRANSACTION_SYNDIC_ADD' || data.action === 'TRANSACTION_SYNDIC_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.trusteeUuid) {
      this.transactionService.getList(null, this.trusteeUuid).subscribe((res: any) => {
        this.transactions = res || [];
      });
    }
  }

  addTransaction(): void {
    this.transactionService.edit = false;
    this.transactionService.setTransactionSyndic(null);
    this.modal(TransactionSyndicAddComponent, 'modal-basic-title', 'lg');
  }

  editTransaction(row: any): void {
    this.transactionService.edit = true;
    this.transactionService.setTransactionSyndic(row);
    this.modal(TransactionSyndicAddComponent, 'modal-basic-title', 'lg');
  }

  deleteTransaction(item: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.transactionService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type, size: size, centered: true, backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
